import "core-js/modules/es.parse-float.js";
// functions here are mostly imported from packages/ab-common/src/pages/ProgramPage/ProgramPage.tsx

var isString = function isString(value) {
  return typeof value === 'string';
};
export var convertToFloat = function convertToFloat(value) {
  if (value === undefined || value === null) {
    return null;
  }
  if (!isString(value)) {
    return value;
  }
  return parseFloat(value);
};
export var getAreEnglishMarksValid = function getAreEnglishMarksValid(toeflMark, ieltsMark, pteMark, duolingoMark) {
  var ielts = convertToFloat(ieltsMark);
  if (ielts && ielts > 0 && ielts <= 9) {
    return true;
  }
  var toefl = convertToFloat(toeflMark);
  if (toefl && toefl > 0 && toefl <= 120) {
    return true;
  }
  // duolingo value is undefined if feature flag is off
  var duolingo = convertToFloat(duolingoMark);
  if (duolingo && duolingo >= 10 && duolingo <= 160) {
    return true;
  }
  var pte = convertToFloat(pteMark);
  if (pte && pte >= 10 && pte <= 90) {
    return true;
  }
  return false;
};
export function elpRequired(pep) {
  if (!pep) {
    return false;
  }
  return pep.minIeltsSpeaking !== 0 || pep.minIeltsWriting !== 0 || pep.minIeltsListening !== 0 || pep.minIeltsReading !== 0 || pep.minIeltsAverage !== 0 || pep.minIeltsAnyBandCount !== null || pep.minIeltsAnyBand !== null || pep.minToeflSpeaking !== 0 || pep.minToeflWriting !== 0 || pep.minToeflListening !== 0 || pep.minToeflReading !== 0 || pep.minToeflTotal !== 0 || pep.minPteSpeaking !== 0 || pep.minPteWriting !== 0 || pep.minPteListening !== 0 || pep.minPteReading !== 0 || pep.minPteOverall !== 0 || pep.minDuolingoScore !== 0;
}
export var extractMarks = function extractMarks(req) {
  return {
    minIeltsSpeaking: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsSpeaking),
    minIeltsWriting: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsWriting),
    minIeltsListening: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsListening),
    minIeltsReading: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsReading),
    minIeltsAverage: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsAverage),
    minIeltsAnyBandCount: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsAnyBandCount),
    minIeltsAnyBand: convertToFloat(req === null || req === void 0 ? void 0 : req.minIeltsAnyBand),
    minToeflSpeaking: convertToFloat(req === null || req === void 0 ? void 0 : req.minToeflSpeaking),
    minToeflWriting: convertToFloat(req === null || req === void 0 ? void 0 : req.minToeflWriting),
    minToeflListening: convertToFloat(req === null || req === void 0 ? void 0 : req.minToeflListening),
    minToeflReading: convertToFloat(req === null || req === void 0 ? void 0 : req.minToeflReading),
    minToeflTotal: convertToFloat(req === null || req === void 0 ? void 0 : req.minToeflTotal),
    minPteSpeaking: convertToFloat(req === null || req === void 0 ? void 0 : req.minPteSpeaking),
    minPteWriting: convertToFloat(req === null || req === void 0 ? void 0 : req.minPteWriting),
    minPteListening: convertToFloat(req === null || req === void 0 ? void 0 : req.minPteListening),
    minPteReading: convertToFloat(req === null || req === void 0 ? void 0 : req.minPteReading),
    minPteOverall: convertToFloat(req === null || req === void 0 ? void 0 : req.minPteOverall),
    minPteAnyBand: null,
    // for future-proofing
    minPteAnyBandCount: null,
    // for future-proofing
    minToeflAnyBand: null,
    // for future-proofing
    minToeflAnyBandCount: null,
    // for future-proofing
    minDuolingoScore: convertToFloat(req === null || req === void 0 ? void 0 : req.minDuolingoScore),
    minDuolingoComprehensionScore: convertToFloat(req === null || req === void 0 ? void 0 : req.minDuolingoComprehensionScore),
    minDuolingoProductionScore: convertToFloat(req === null || req === void 0 ? void 0 : req.minDuolingoProductionScore),
    minDuolingoConversationScore: convertToFloat(req === null || req === void 0 ? void 0 : req.minDuolingoConversationScore),
    minDuolingoLiteracyScore: convertToFloat(req === null || req === void 0 ? void 0 : req.minDuolingoLiteracyScore)
  };
};